import { useState } from "react";
import { X } from "lucide-react";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/;

// Chip-style list of email addresses; Enter, comma or blur adds the typed address.
export function RecipientInput({ value, onChange, testId, placeholder }) {
  const [text, setText] = useState("");
  const [err, setErr] = useState("");
  const add = () => {
    const parts = text.split(/[,;\s]+/).map((s) => s.trim()).filter(Boolean);
    if (!parts.length) return;
    const bad = parts.filter((p) => !EMAIL_RE.test(p));
    if (bad.length) { setErr(`Not a valid email: ${bad.join(", ")}`); return; }
    onChange([...new Set([...value, ...parts.map((p) => p.toLowerCase())])]);
    setText(""); setErr("");
  };
  return (
    <div>
      <div className="flex flex-wrap items-center gap-1.5 border border-slate-200 rounded-md px-2 py-1.5 min-h-[38px] focus-within:ring-2 focus-within:ring-indigo-200" data-testid={testId}>
        {value.map((a) => (
          <span key={a} className="inline-flex items-center gap-1 bg-indigo-50 text-indigo-800 text-xs rounded px-2 py-0.5" data-testid={`${testId}-chip-${a}`}>
            {a}
            <button type="button" onClick={() => onChange(value.filter((x) => x !== a))} className="hover:text-rose-600" aria-label={`Remove ${a}`} data-testid={`${testId}-remove-${a}`}><X className="w-3 h-3" /></button>
          </span>
        ))}
        <input value={text} onChange={(e) => { setText(e.target.value); setErr(""); }} onBlur={add} placeholder={value.length ? "" : placeholder}
          onKeyDown={(e) => { if (["Enter", ",", ";"].includes(e.key)) { e.preventDefault(); add(); } else if (e.key === "Backspace" && !text && value.length) onChange(value.slice(0, -1)); }}
          className="flex-1 min-w-[160px] text-sm outline-none bg-transparent py-0.5" data-testid={`${testId}-input`} />
      </div>
      {err && <div className="text-xs text-rose-600 mt-1" data-testid={`${testId}-error`}>{err}</div>}
    </div>
  );
}
